// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.c-store-over-capacity[data-v-63b14f9f] {
  font-size: 0.9375rem;
  line-height: 1.6;
  color: #8a949a;
}
`, "",{"version":3,"sources":["webpack://./resources/assets/vue/components/StoreCard.vue"],"names":[],"mappings":";AAmaA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["\n.c-store-over-capacity {\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  color: #8a949a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
